import React from "react"
import { Fade, Col } from "react-bootstrap"
import "bootstrap/dist/css/bootstrap.min.css"
import "react-day-picker/lib/style.css"
import "dropzone/dist/min/dropzone.min.css"
import "../../content/assets/nav-slide-effect.css"
import "../../content/assets/font-awesome.min.css"
import "../../content/NewUIHomeFlexi.css"
import "../../content/font.css"
import FunctionalFooter from "./functionalFooter"
import { useSelector, useDispatch, shallowEqual } from "react-redux"
import { controlDeclaration, checkboxStatusUpdate } from "../../redux/actions"
import EtiqaHeader from "./etiqaHeader"
import IdleTimeOutModal from "../idleTimeOutModal"
import GatsbyConfig from "../../../gatsby-config"
import "../../content/Site.css"

if (process.env.THEME == "Etiqa") {
  require("../../content/ThemeYellow.css") // Etiqa theme CSS
}

const themeLogo = GatsbyConfig.siteMetadata.themeLogo
const theme = GatsbyConfig.siteMetadata.theme
let logo = require("../../content/img/" + themeLogo)

const FunctionalLayout = ({ children }) => {
  const dispatch = useDispatch()
  const uiData = useSelector(state => state.uiData, shallowEqual)
  const claimData = useSelector(state => state.claimData, shallowEqual)
  const showLoading = useSelector(
    state => state.uiData.showLoading,
    shallowEqual
  )
  const pageNumber = useSelector(state => state.uiData.pageNumber, shallowEqual)
  const claimFormTitle = useSelector(
    state => state.uiData.claimFormTitle,
    shallowEqual
  )
  const showDeclaration = useSelector(
    state => state.uiData.showDeclaration,
    shallowEqual
  )
  const isAgree = useSelector(
    state => state.uiData.checkBoxStatus.isAgree,
    shallowEqual
  )

  const handleDeclarationChange = () => {
    dispatch(controlDeclaration())
  }

  return (
    <>
      {!uiData.hideHeaderFooter && (
        <EtiqaHeader logo={logo} claimFormTitle={claimFormTitle} />
      )}

      <Fade in={showLoading} className={!showLoading ? "hide" : ""}>
        <div className="opaque app-loading">
          <div
            className={
              "icon-loading " + (theme === "Etiqa" ? "animate-flicker" : "")
            }
          ></div>
        </div>
      </Fade>

      <div>
        <main>{children}</main>
        <div
          className={
            "declarationBackground " + (showDeclaration ? "show" : "hide")
          }
          onClick={handleDeclarationChange}
          onKeyDown={handleDeclarationChange}
          role="button"
          styling="link"
          tabIndex="0"
        ></div>
        <div
          className={
            "backgroundWhite pageDeclaration container " +
            (showDeclaration ? "show" : "hide")
          }
        >
          <div className={"form-group " + (showDeclaration ? "show" : "hide")}>
            <div className="declarationTitleText">
              {"Declaration, Authorization & Customer's Data Privacy Consent"}
            </div>
            <p className="text-justify">
              <span className="paragraphTitle">[Declaration]</span>{" "}
              <span className="paragraphText">
                I/We declare that the information given in this form is true and
                correct to the best of my knowledge and belief. I/We understand
                that all information and supporting documents may be subject to
                review by Etiqa and Etiqa shall reserves all rights to reject
                any claims, recover any and all amounts, or to impose additional
                charges if for any reason any claim is found to be fraudulent.
                Etiqa shall also reserve the right to pursue any actions at law
                or in equity that it deems appropriate in dealing with such
                fraudulent activity.
              </span>
            </p>
            <p className="text-justify">
              <span className="paragraphTitle">[Declaration]</span>{" "}
              <span className="paragraphText">
                I/We declare that the e-bills submitted are indeed what were
                received from the public healthcare institutions. Etiqa reserves
                the rights to request for the original bills or certified true
                copies and to contact the public healthcare institutions
                directly if needed for validation of the bill authenticity.
              </span>
            </p>
            <p className="text-justify">
              <span className="paragraphTitle">[Authorization]</span>{" "}
              <span className="paragraphText">
                I/We hereby consent to and authorize the medical practitioner
                involved in the claimant’s care to discuss and disclose
                treatment details and discharge arrangements with and to Etiqa
                Insurance Pte Ltd. I/We agree that a copy of this consent shall
                have the validity of the original.
              </span>
            </p>
            <p className="text-justify">
              <span className="paragraphTitle">
                [Customer’s Data Privacy Consent]
              </span>{" "}
              <span className="paragraphText">
                I/We further declared that the information written in this claim
                form or held by Etiqa Insurance Pte Ltd whether contained in
                my/our insurance application or otherwise obtained may be used
                and disclosed to your authorised staff, associated individuals
                and/or companies or any independent third parties (within or
                outside Singapore) who will provide claims administrative,
                advice and/or information or claims services in relation to
                my/our claim. I/We understand my/our data that may also be used
                for audit, business analysis and reinsurance purposes.
              </span>
            </p>
          </div>
          <Col
            xs={12}
            md={12}
            className={"marginTop10px CheckBox " + (isAgree ? "tick" : "")}
            onClick={() => dispatch(checkboxStatusUpdate("isAgree"))}
            role="button"
          >
            {"I/We agree to abide by the terms & conditions."}
          </Col>
        </div>

        <FunctionalFooter
          pageNumber={pageNumber}
          uiData={uiData}
          claimData={claimData}
        />
      </div>

      <IdleTimeOutModal />
    </>
  )
}

export default FunctionalLayout
